import { useOrganisationIntegration } from './useOrganisationIntegration';

const EXCEL_INTEGRATION_ID = '077d8fd8-1ebd-4535-ba21-ddfd88b7b7fd';

export const useIsExcelOrganisation = (workspaceId?: string, organisationId?: string) => {
  const { organisation } = useOrganisationIntegration(workspaceId, organisationId);
  return organisation?.datasource?.integration_id === EXCEL_INTEGRATION_ID;
};
